import { useEffect, useRef, useState } from "react";
import { WS_URL } from "./config";
import { getToken } from "./token";

const KEEPALIVE_MS = 25000;

const RETRY_DELAYS_MS = [1000, 2000, 4000, 8000, 15000];

export function useBoard(category, aktywne = true) {
  const [tasks, setZadania] = useState([]);
  const [stan, setStan] = useState("laczenie");
  const socketRef = useRef(null);
  const attemptRef = useRef(0);
  const timersRef = useRef([]);

  useEffect(() => {
    if (!aktywne) return undefined;

    let closed = false;

    const wyczyscCzasomierze = () => {
      timersRef.current.forEach(clearTimeout);
      timersRef.current.forEach(clearInterval);
      timersRef.current = [];
    };

    const request = () => {
      const ws = socketRef.current;
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify(category ? { category: category } : {}));
      }
    };

    const connect = () => {
      if (closed) return;
      setStan((s) => (s === "polaczono" ? s : "laczenie"));

      const ws = new WebSocket(`${WS_URL}?token=${getToken()}`);
      socketRef.current = ws;

      ws.onopen = () => {
        attemptRef.current = 0;
        setStan("polaczono");
        request();
        const podtrzymanie = setInterval(() => {
          if (document.visibilityState === "visible") request();
        }, KEEPALIVE_MS);
        timersRef.current.push(podtrzymanie);
      };

      ws.onmessage = (zdarzenie) => {
        try {
          const dane = JSON.parse(zdarzenie.data);
          if (Array.isArray(dane)) setZadania(dane);
        } catch (e) {
          console.error("Nieczytelna ramka z serwera", e);
        }
      };

      ws.onclose = () => {
        if (closed) return;
        setStan("wznawianie");
        const attempt = attemptRef.current++;
        const delay = RETRY_DELAYS_MS[Math.min(attempt, RETRY_DELAYS_MS.length - 1)];
        const czasomierz = setTimeout(connect, delay);
        timersRef.current.push(czasomierz);
      };

      ws.onerror = () => ws.close();
    };

    const onVisible = () => {
      if (document.visibilityState !== "visible") return;
      const ws = socketRef.current;
      if (!ws || ws.readyState === WebSocket.CLOSED) {
        attemptRef.current = 0;
        connect();
      } else if (ws.readyState === WebSocket.OPEN) {
        request();
      }
    };

    connect();
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("online", onVisible);

    return () => {
      closed = true;
      wyczyscCzasomierze();
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("online", onVisible);
      if (socketRef.current) socketRef.current.close();
    };
  }, [category, aktywne]);

  return { tasks, stan, setZadania };
}
